export const trademarkString = ""